// @ts-nocheck
/* eslint-disable */
import Melown3dLayer from "./layer";
import Melown3dMarker from "./marker";

export default class Melown3dLayerDistanceMeter extends Melown3dLayer {
	/**
	 * Vytvoreni vrstvy ve 3d, ktera dokaze zobrazovat rucni mereni.
	 *
	 * @param {Array} points Body rucniho mereni WGS84 [x,y, volitelne z]
	 * @param {Array} linePoints Body rucniho mereni pro vykresleni car WGS84 [x,y,z]
	 * @param {Object} style Vizualni nastaveni vrstvy
	 */
	constructor(points, linePoints, style) {
		super();

		this._points = [];
		this._linePoints = [];
		this._style = {
			startTexture: null,
			texture: null,
			lineColor: [255, 0, 0, 255],
			outlineColor: [255, 255, 255, 255 * 0.8],
			lineWidth: 4,
			outlineWidth: 0,
			depthOffset: [-0.2, 0, 0]
		};

		this.update(points, linePoints, style);
	}

	update(points = [], linePoints = [], style = {}) {
		this._clear();

		this._points = points;
		this._linePoints = linePoints;

		Object.assign(this._style, style);

		this._createMarkers();
		this.redraw();
	}

	render() {
		if (!this._melownCore) return;

		let size = this._melownCore.renderer.getCanvasSize();
		let pos = this._presenter.getPosition();
		let visible = [];

		this._markers.forEach(marker => {
			// spocitame a zjistime, jestli je marker viditelny
			if (marker.calc(size[0], size[1], pos)) {
				visible.push(marker);
			}
		});

		// volna vrstva + markery - fix z indexu
		let tmpState = this._melownCore.renderer.createState({});
		this._melownCore.renderer.setState(tmpState);

		// nachystame si vykresleni car
		if (this._linePoints.length) {
			let points = [];

			this._linePoints.forEach(point => {
				points.push(this._melownCore.map.convertCoordsFromNavToPhys([point[0], point[1], 0], 'float', null, true));
			});

			// kresleni
			if (this._style.outlineWidth > 0) {
				this._melownCore.renderer.drawLineString({
					points,
					color: this._style.outlineColor.slice(),
					size: this._style.outlineWidth,
					depthTest : false,
					screenSpace : false, //switch to physical space
					blend: this._style.outlineColor[2] != 255
				});
			}

			this._melownCore.renderer.drawLineString({
				points,
				color: this._style.lineColor.slice(),
				size: this._style.lineWidth,
				depthTest : false,
				screenSpace : false, //switch to physical space
				blend: this._style.lineColor[2] != 255
			});
		}

		this._drawMarkers(visible, pos);
	}

	// tyto metody nic nevraci
	click(x, y) {
	}

	move(x, y) {
	}

	getMarker(x, y) {
		return null;
	}

	/**
	 * Odstraneni vsech entit.
	 */
	removeAll() {
		this._clear();
		this.redraw();
	}

	/**
	 * Ziskani vsech entit.
	 *
	 * @return {Array}
	 */
	getEntities() {
		return [];
	}

	_clear() {
		this._points.length = 0;
		this._linePoints.length = 0;

		while (this._markers.length) {
			let marker = this._markers.pop();
			marker.destroy();
		}
	}

	_createMarkers() {
		let markers = [];

		// vytvorime markery z bodu
		this._points.forEach((point, ind) => {
			let texture = {};

			if (!ind) {
				// start
				texture.active = this._style.startTexture;
				texture.nonActive = this._style.startTexture;
			}
			else {
				texture.active = this._style.texture;
				texture.nonActive = this._style.texture;
			}

			let marker = new Melown3dMarker(point[0], point[1], {
				depthOffset: this._style.depthOffset
			}, texture);
			markers.push(marker);
		});

		if (markers.length) {
			this.addMarker(markers);
		}
	}
}
